import Grid from '@material-ui/core/Grid';
import CheckCircle from '@material-ui/icons/CheckCircle';
import { makeStyles } from '@material-ui/styles';
import classNames from 'classnames';
import React from 'react';
import PropTypes from '../../helpers/propTypes';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: 'white',
    flex: '33.33%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '11px',
    color: theme.palette.grey[600],
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    lineHeight: '24px',
    fontFamily: theme.typography.fontFamily,

    '&:not(:last-of-type)': {
      borderRight: '1px solid #ccc',
    },
  },

  complete: {
    backgroundColor: theme.palette.primary.extraLight,
    color: theme.palette.primary.main,
    opacity: '0.5',
  },

  active: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    fontWeight: 'bold',
  },

  default: {
    backgroundColor: 'white',
  },

  icon: {
    marginLeft: 8,
    fontSize: 16,
    color: theme.palette.primary.main,
  },
}));

function NavigationProgressItem({ item, progress, index }) {
  const classes = useStyles();

  return (
    <Grid
      className={classNames(
        classes.root,
        { [classes.active]: progress === index },
        { [classes.complete]: progress > index },
        { [classes.default]: progress < index },
      )}
      item
    >
      {item}
      {progress > index && <CheckCircle className={classes.icon} />}
    </Grid>
  );
}

NavigationProgressItem.propTypes = {
  index: PropTypes.number.isRequired,
  item: PropTypes.node.isRequired,
  progress: PropTypes.number.isRequired,
};

export default NavigationProgressItem;
